import React, { useState, useEffect } from "react";
import Navbar from './Navbar';
import { Card } from "react-bootstrap";
import '../assets/css/dashlite.css';
import '../assets/css/theme.css';
import '../assets/css/Custom.css';
import { AuthToken, BASE_URL } from "../Constants";
import { useNavigate } from "react-router-dom";
import Countdown from "react-countdown";
import { zeroPad } from "react-countdown";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Backdrop, CircularProgress } from '@mui/material';
import { Modal, Button } from "react-bootstrap";
import "./TestResult.css";



const TestResult = () => {
    const [Rdata, setRdata] = useState("noloader");
    const [MockTestID, setMockTestID] = useState();
    const [StudentID, setStudentID] = useState(localStorage.getItem("StudentID"));
    const [TotalStudents, setTotalStudents] = useState(0);
    const [TotalMarks, setTotalMarks] = useState(0);
    const [Percentile, setPercentile] = useState(0);
    const [TotalQuestions, setTotalQuestions] = useState(0);
    const [CorrectQuestions, setCorrectQuestions] = useState(0);
    const [WrongQuestions, setWrongQuestions] = useState(0);
    const [SkippedQuestions, setSkippedQuestions] = useState(0);
    const [SubmitDate, setSubmitDate] = useState(0);
    const [showConfirm, setShowConfirm] = useState(false);

    const handleOpenConfirm = () => setShowConfirm(true);
    const handleCloseConfirm = () => setShowConfirm(false);


    const EmailID = localStorage.getItem('EmailID');
    const navigate = useNavigate();

    //Disable Back Button//
    var ctrlKeyDown = false;
    useEffect(() => {
        const handleBackButton = (e) => {
            e.preventDefault();
            navigate('/mock-test');
        };

        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', handleBackButton);

        return () => {
            window.removeEventListener('popstate', handleBackButton);
        };
    }, []);

    //Disable Refresh and ctrl R//


    function my_onkeydown_handler(e) {
        switch (e.keyCode) {
            case 116: // 'F5'
                e.preventDefault();
                e.keyCode = 0;
                window.status = "F5 disabled";
                break;
        }

        if ((e.which || e.keyCode) == 116 || ((e.which || e.keyCode) == 82 && ctrlKeyDown)) {
            // Pressing F5 or Ctrl+R
            e.preventDefault();
        } else if ((e.which || e.keyCode) == 17) {
            // Pressing  only Ctrl
            ctrlKeyDown = true;
        }
    }

    //window.onbeforeunload = function () {navigate('/instruction');}
    // window.onbeforeunload = () => "If you leave this page, you'll also leave the call";

    //



    //Disable Back Button//
    document.addEventListener('contextmenu', (e) => e.preventDefault());

    function ctrlShiftKey(e, keyCode) {
        return e.ctrlKey && e.shiftKey && e.keyCode === keyCode.charCodeAt(0);
    }


    useEffect(() => {
        const handleBackButton = (e) => {
            e.preventDefault();
            navigate('/mock-test');
        };

        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', handleBackButton);

        return () => {
            window.removeEventListener('popstate', handleBackButton);
        };
    }, []);


    const NavigateTest = (event) => {
        event.preventDefault();

        // extra safety
        window.onbeforeunload = null;

        localStorage.setItem("retake", "yes");
        navigate('/mock-test');
    };



    //Disable Back Button//
    function hndlePageLoad() {
        alert("Page loads");
    }
    useEffect(() => {

        setRdata("showloader");
        fetch(BASE_URL + "/mocktest/get-mock-test-result", {
            method: "POST",
            body: JSON.stringify({ MockTestID, AuthToken, StudentID }),
            headers: {
                "Content-Type": "application/json",
                'API_KEY': AuthToken
            },
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.message === "Call Successful") {
                    setRdata("noloader");
                    setTotalStudents(data.data?.TotalStudents);
                    setTotalMarks(data.data?.TotalMarks);
                    setPercentile(data.data?.Percentile);
                    setTotalQuestions(data.data?.TotalQuestions);
                    setWrongQuestions(data.data?.WrongQuestions);
                    setSkippedQuestions(data.data?.SkippedQuestions);
                    setCorrectQuestions(data.data?.CorrectQuestions);
                    setSubmitDate(data.data?.SubmitDate);
                }
                else {
                    setRdata("noloader");
                    toast.error(data.data?.ErrorMessage);
                }
            }

            );

    }, []);



    return (
        <>
            <Navbar />

            <div >

                <form>
                    <div className="nk-app-root">
                        <div className="nk-main">
                            <div className="nk-wrap nk-wrap-nosidebar">
                                <div className="nk-content ">
                                    <div className="col-md-12">

                                        <div className="card card-bordered">
                                            <div className="col-md-12">

                                                <div>

                                                    <h3 style={{ marginTop: "21px" }}>All India Prelims Mock Test CSAT (Nov - Dec 2025)</h3>
                                                    <h4 style={{ marginBottom: "28px" }}>Result Summary</h4>
                                                    <p className="pp">

                                                        <div
                                                            style={{
                                                                width: "100%",
                                                                marginTop: "30px"
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    width: "100%",
                                                                    border: "1px solid #535252ff",
                                                                }}
                                                                className="table-chart"
                                                            >
                                                                <table
                                                                    className="table table-striped"
                                                                    style={{
                                                                        background: "#fff",
                                                                        borderRadius: "12px",
                                                                        overflow: "hidden",
                                                                        boxShadow: "0 3px 20px rgba(0,0,0,0.08)",
                                                                        width: "100%",
                                                                        border: "1px solid #535252ff",     // outer border
                                                                        borderCollapse: "collapse",    // ensures inner borders show
                                                                    }}
                                                                >
                                                                    <thead style={{ background: "#f8f9fc" }}>
                                                                        <tr>
                                                                            <th style={{ padding: "14px", border: "1px solid #000" }}></th>
                                                                            <th style={{ padding: "14px", border: "1px solid #000" }}>Description</th>
                                                                            <th style={{ padding: "14px", border: "1px solid #000" }}>Value</th>
                                                                        </tr>
                                                                    </thead>

                                                                    <tbody>
                                                                        <tr>
                                                                            <td style={{ border: "1px solid #000" }}>1</td>
                                                                            <td style={{ border: "1px solid #000" }}><b>Total Marks</b></td>
                                                                            <td style={{ border: "1px solid #000" }}>{TotalMarks}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td style={{ border: "1px solid #000" }}>2</td>
                                                                            <td style={{ border: "1px solid #000" }}><b>Total Questions</b></td>
                                                                            <td style={{ border: "1px solid #000" }}>{TotalQuestions}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td style={{ border: "1px solid #000" }}>3</td>
                                                                            <td style={{ border: "1px solid #000" }}><b>Correct Questions</b></td>
                                                                            <td style={{ border: "1px solid #000" }}>{CorrectQuestions}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td style={{ border: "1px solid #000" }}>4</td>
                                                                            <td style={{ border: "1px solid #000" }}><b>Wrong Questions</b></td>
                                                                            <td style={{ border: "1px solid #000" }}>{WrongQuestions}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td style={{ border: "1px solid #000" }}>5</td>
                                                                            <td style={{ border: "1px solid #000" }}><b>Skipped Questions</b></td>
                                                                            <td style={{ border: "1px solid #000" }}>{SkippedQuestions}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td style={{ border: "1px solid #000" }}>6</td>
                                                                            <td style={{ border: "1px solid #000" }}><b>Attempted On</b></td>
                                                                            <td style={{ border: "1px solid #000" }}>{SubmitDate}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>

                                                        </div>



                                                    </p>
                                                    <br />
                                                    <div style={{ paddingBottom: "20px" }}>
                                                        <span style={{ color: "red" }}>Note: Final ranking will be emailed to you on <span>{EmailID}</span></span>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        onClick={handleOpenConfirm}
                                                        className="btn btn-primary"
                                                        style={{ marginBottom: "25px" }}
                                                    >
                                                        Retake Test
                                                    </button>

                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>

                </form>



                {Rdata === "showloader" ?
                    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open>
                        <CircularProgress color="inherit" />
                    </Backdrop> : ""
                }

            </div >
            <Modal show={showConfirm} centered>
                <Modal.Header >
                    <Modal.Title>Retake Test?</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    Are you sure you want to retake the test?
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseConfirm}>
                        Cancel
                    </Button>

                    <Button
                        variant="primary"
                        onClick={(e) => {
                            // IMPORTANT: disable leave warning before navigation
                            window.onbeforeunload = null;
                            handleCloseConfirm();
                            NavigateTest(e);
                        }}
                    >
                        Yes, Retake
                    </Button>

                </Modal.Footer>
            </Modal>


        </>
    )
}

export default TestResult